import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { Button, Grid, Paper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import cdac from './cdac.jpg';
import adven from './adventour.jpg';
import shillong from './shillong.jpg';
import sing from './sing.jpg';
import friends from './friends.jpg';
import useWindowPosition from '../../hook/useWindowPosition';

const useStyles = makeStyles({
	root: {
		flexGrow: 1,
		display: 'contents',
	},

	card: {
		maxWidth: 300,
		marginRight: '3px',
		marginLeft: '6px',
		// marginBottom: "8px",
		marginTop: '15px',

		// backgroundColor: "black"
	},
	media: {
		height: 180,
	},

	typo1: {
		color: '#065c6f',
		fontSize: '36px',
		fontWeight: '700',
		fontFamily: ' Montserrat,"Helvetica Neue",Helvetica,Arial,sans-serif',
	},

	fun: {
		color: 'black',
		fontSize: '21px',
		fontWeight: '400',
		fontFamily: ' calibri',
		paddingLeft: '10px',
		paddingRight: '10px',
	},

	subheader: {
		//  color: 'black',
		fontSize: '16px',
		letterSpacing: '0.6px',
		fontWeight: '500',
		// fontFamily: ' calibri',
	},
});

export default function Leisure() {
	const classes = useStyles();

	const animated = useWindowPosition('header', 0.6);

	return (
		<>
			<Grid
				container
				direction="column"
				alignItems="center"
				justifyContent="space-around"
				// id="projects"
				className={classes.root}
				spacing={2}
				style={{
					transform: animated ? 'translate(-10%, 0%) rotate3d(0.540, -0.95, 0, 360deg) rotateZ(0deg)' : '',
				}}
			>
				<Grid item xs={12} justify="center" style={{ marginTop: '3vw', textAlign: 'center' }}>
					<h1 className="transtion duration-2000 ease-in-out text-5xl font-dosis font-bold ">Fun Facts</h1>
				</Grid>
				<Grid item xs={12} justify="center" style={{ marginTop: '1vw', textAlign: 'center' }}>
					<p className="transtion duration-2000 ease-in-out w-11/12 md:max-w-xl text-center inline-block text-xl md:text-2xl font-dosis ">
						Fun facts are more descriptive in pictures than in words.
					</p>
				</Grid>
				<Grid
					item
					xs={12}
					style={{
						marginTop: '3vw',
					}}
				>
					<Grid
						container
						justify="center"
						spacing={2}
						// style={{

						// 	transform: animated
						// 		? 'translate(-10%, 0%) rotate3d(0.540, -0.95, 0, 360deg) rotateZ(0deg)'
						// 		: '',

						// }}
					>
						<Card className={classes.card}>
							<CardMedia className={classes.media} image={sing} />

							<CardContent>
								<Typography gutterBottom variant="h5" component="h2">
									Performer
								</Typography>
								<p className="transtion duration-2000 ease-in-out w-11/12 md:max-w-xl text-left inline-block text-xl md:text-xl font-dosis " style={{fontWeight: "500"}}>
									I love to perform whenever i get chance, be it on-stage or off-stage.
								</p>
							</CardContent>
						</Card>

						<Card className={classes.card}>
							<CardActionArea>
								<CardMedia className={classes.media} image={shillong} />

								<CardContent>
									<Typography gutterBottom variant="h5" component="h2" >
										Explorer
									</Typography>
									<p className="transtion duration-2000 ease-in-out w-11/12 md:max-w-xl text-left inline-block text-xl md:text-xl font-dosis " style={{fontWeight: "500"}}>
										Love to explore places, cultures and food habits whenever i get a chance.
									</p>
								</CardContent>
							</CardActionArea>
						</Card>

						<Card className={classes.card}>
							<CardActionArea>
								<CardMedia className={classes.media} image={adven} />

								<CardContent>
									<Typography gutterBottom variant="h5" component="h2">
										Adventurer
									</Typography>
									<p className="transtion duration-2000 ease-in-out w-11/12 md:max-w-xl text-left inline-block text-xl md:text-xl font-dosis " style={{fontWeight: "500"}}>
										Adventures is in my blood. It immensely helps me in productivity.
									</p>
								</CardContent>
							</CardActionArea>
						</Card>

						
					</Grid>
				</Grid>
			</Grid>
		</>
	);
}
